module.exports = __webpack_public_path__ + "img/Card_spade_4.10d472df.svg";